import React from 'react';

import NotFound from 'Components/Feedback/NotFound/NotFound';
import SkeletonPlaceholder from 'Components/Progress/SkeletonPlaceholder';

/**
 * Handles rendering logic for product states.
 * @param {Object} options - The options for rendering.
 * @param {string} options.urlRedirect - URL to redirect to.
 * @param {string} options.matchUrl - Current match URL.
 * @param {string} options.redirect - Redirect URL.
 * @param {boolean} options.notFound - Whether the product is not found.
 * @param {boolean} options.isLoading - Whether the product is loading.
 * @param {Object} options.product - The product object.
 * @returns {JSX.Element|boolean} - The appropriate JSX or `false`.
 */
const ProductStatusRenderer = ({
  urlRedirect,
  matchUrl,
  redirect,
  notFound,
  isLoading,
  product,
}) => {
  if (urlRedirect && `/${urlRedirect}` !== matchUrl) {
    setTimeout(() => {
      window.prerenderReady = true;
    }, 1500);
    return <NotFound redirect={urlRedirect} />;
  }

  if (redirect) {
    setTimeout(() => {
      window.prerenderReady = true;
    }, 1500);
    return <NotFound redirect={redirect} />;
  }

  if (notFound) return <NotFound />;

  if (isLoading) {
    return <SkeletonPlaceholder />;
  }

  if (!product) return false;

  return false; // Return false if none of the conditions are met
};

export default ProductStatusRenderer;
